import { render, staticRenderFns } from "./viewLeave.vue?vue&type=template&id=48c97daf&scoped=true&"
import script from "./viewLeave.vue?vue&type=script&lang=js&"
export * from "./viewLeave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c97daf",
  null
  
)

export default component.exports